import { z } from 'zod';

const commonEvents = z.enum(['email_sent']);
export const timelineEventType = z.enum([...commonEvents.options]);
